export default __webpack_public_path__ + "static/media/poster1.0a8c3576.jpg";